import React from "react";

export const PrevTerm1 = () => {
    return (
        <div className="previous-terms-content">
            {/* 6. (스마트올중학) 개인정보처리방침(20.12 제정) */}
            <h1>개인정보처리방침</h1>
            <h2>스마트올중학_(2020.12.01)</h2>
            <h2>개인정보 처리방침</h2>
            <p>
                (주) 웅진씽크빅(이하 “회사”라 한다)이 운영하는 웅진 스마트올중학 은 「정보통신망 이용촉진 및 정보보호에
                관한 법률」 및 「개인정보보호법」을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익
                보호에 최선을 다하고 있습니다. 스마트올중학의 개인정보 처리방침은 정부의 법률 및 지침 변경이나 약관 및
                내부 정책에 따라 변경될 수 있으며, 이를 개정하는 경우 당사의 홈페이지에 변경사항을 즉시 게시합니다. 본
                방침은 2020년 12월 01일부터 시행되며, 회사는 이를 개정하는 경우 웹사이트 공지사항(또는 개별공지)을
                통하여 공지하겠습니다.
            </p>
            <div>
                <h2>개요</h2>
                <p>개인정보처리방침은 다음과 같은 내용을 담고 있습니다. </p>
                <p>1. 수집 개인정보 항목 및 수집방법</p>
                <p>2. 개인정보 수집 및 이용 목적</p>
                <p>3. 개인정보의 보유 및 이용기간</p>
                <p>4. 개인정보 제3자 공유 및 제공</p>
                <p>5. 개인정보 취급 위탁</p>
                <p>6. 개인정보의 파기와 방법</p>
                <p>7. 이용자의 권리(처리방침)와 그 행사 방법</p>
                <p>8. 이용자의 법정대리인의 권리와 행사 방법</p>
                <p>9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</p>
                <p>10. 개인정보의 기술적 / 관리적 보호 대책</p>
                <p>11. 개인정보관리책임자 및 담당자의 연락처</p>
                <p>12. 고지의 의무</p>
            </div>
            <div>
                <h2>1. 수집 개인정보 항목 및 수집방법</h2>
                <h3>가. 수집하는 개인정보의 항목</h3>
                <p>첫째. 체험 및 상담을 위한 최초 회원 정보 수집을 통해 최적화된 서비스를 제공합니다.</p>
                <p>-항목 : 성명, 휴대폰번호, 자녀학년</p>
                <p>
                    둘째. 회사는 원활한 교육상담 및 각종 서비스 제공을 위해 아래의 추가정보를 수집할 수 있으나, 이용자가
                    원치 않을 경우 선택적 미 동의가 가능합니다.
                </p>
                <p>-항목 : 생년월일, 주소, 이메일, 자녀정보(이름, 생년월일, 학년, 성별, 휴대폰번호), 녹취자료</p>
                <p>셋째. 서비스 결제 과정 진행 시, 아래와 같은 결제 정보들이 수집될 수 있습니다.</p>
                <p>
                    -항목 : (신용카드 결제 시) 카드소유주, 생년월일, 카드사명, 카드번호, 유효기간 등 / (계좌 이체 시)
                    은행명, 계좌번호 등
                </p>
                <p>넷째. 서비스 이용 및 사업처리 과정에서 아래의 정보들이 자동으로 생성되어 수집될 수 있습니다.</p>
                <p>-접속IP정보, 쿠키, 결제기록, 접속로그, 서비스 이용 기록, 불량 이용 기록 등.</p>
                <h3>나. 개인정보 수집방법</h3>
                <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다</p>
                <p>- 홈페이지, 서면양식, 전화/팩스를 통한 회원가입, 행사응모, 결제진행, 배송요청</p>
                <p>- 전화를 통한 개인정보 수집 : 통화내용 녹취 (녹취내용 사전 이용자 고지)</p>
            </div>
            <div>
                <h2>2. 개인정보 수집 및 이용 목적</h2>
                <p>회사는 다음 목적을 위해 이용자의 개인정보를 수집 및 처리합니다. </p>
                <p>
                    - 서비스 제공 : 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 본인인증, 컨텐츠 제공, 구매 및
                    요금 결제, 요금추심, 물품배송 및 청구지 등 발송
                </p>
                <p>
                    - 회원관리 : (본인 확인에 따른) 제한적 서비스 제공을 위한 기본 본인확인, 개인식별, 불량회원 부정
                    이용 방지 및 비인가 사용 방지, 가입 및 가입횟수 제한, 연령확인, 분쟁처리를 위한 기록보존, 불만처리
                    및 민원처리, 고지사항 전달
                </p>
                <p>
                    - 마케팅 및 광고에 활용 : 신규서비스(제품) 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스
                    제공 및 광고 게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도 파악,
                    회원의 서비스 이용에 대한 통계
                </p>
            </div>

            <div>
                <h2>3. 개인정보의 보유 및 이용기간</h2>
                <p>
                    회사는 서비스 가입일로부터 제공하는 기간 동안에 한하여, 이용자의 개인정보를 보유 및 이용하게 됩니다.
                    이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적에 달성될 경우 지체 없이 파기합니다. 단,
                    다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다
                </p>
                <h3>가. 회사 내부 방침에 의한 정보 보유 사유</h3>
                <p>
                    -회원 탈퇴 시 보존 개인정보 <br />
                    보존항목: 이름, 이메일 주소, 전화번호, 주소
                    <br />
                    보존 근거: 명예회손 등 권리침해 분쟁 및 수사협조
                    <br />
                    보존기간: 회원 탈퇴 후 1년
                </p>
                <h3>나. 관련법령에 의한 정보보유 사유</h3>
                <p>
                    상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우
                    회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우, 회사는 보관하는 정보를 그
                    보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
                </p>
                <p>- 계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</p>
                <p>- 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</p>
                <p>- 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래 등에서의 소비자보호에 관한 법률)</p>
                <p>- 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (신용정보의 이용 및 보호에 관한 법률)</p>
                <p>- 표시/광고에 관한 기록 : 6개월 (전자상거래 등에서의 소비자보호에 관한 법률)</p>
            </div>

            <div>
                <h2>4. 개인정보 제3자 공유 및 제공</h2>
                <h3>
                    회사는 이용자들의 개인정보를 [개인정보의 수집목적 및 이용목적]에서 고지한 범위 내에서 사용하며,
                    이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에
                    공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
                </h3>
                <p>
                    - 이용자들이 사전 공개에 동의한 경우 (사전 동의를 얻고자 할때는 미리 개별 서면, 이메일, 전화 등으로
                    해당사항을 알림)
                </p>
                <p>
                    - 법령 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
                    제공받는 자
                </p>
                <table>
                    <tbody>
                        <tr>
                            <th>제공받는 업체 </th>
                            <th>제공 목적</th>
                            <th>제공 항목</th>
                        </tr>
                        <tr>
                            <td>나이스평가정보㈜ / 코리아크레딧뷰로(KCB) 주식회사</td>
                            <td>
                                계약체결 및 연체관리 목적을 위한 정보 조회 (신용등급, 연체정보, 대출정보, 식별정보),
                                채무불이행 등재
                            </td>
                            <td>성명, 법정 생년월일, 주소, 연락처, E-mail, 결제정보</td>
                        </tr>
                        <tr>
                            <td>SKN(리포나) / MPGIO</td>
                            <td>A/S 및 리퍼비시</td>
                            <td>성명, 주소, 서비스 가입일</td>
                        </tr>
                        <tr>
                            <td>주식회사 웅진, 웅진릴리에뜨</td>
                            <td>상품 소개 및 마케팅</td>
                            <td>성명, 휴대폰번호, E-mail</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <h2>5. 개인정보 취급 위탁</h2>
                <h3>
                    회사는 목적에 맞는 원활한 서비스 제공을 위해 아래와 같이 개인정보를 위탁하고 있으며, 관계 법령에
                    따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
                </h3>
                <table>
                    <tbody>
                        <tr>
                            <th>수탁 업체</th>
                            <th>위탁 목적</th>
                            <th>위탁 항목</th>
                        </tr>
                        <tr>
                            <td>주식회사 웅진 / KLCNS </td>
                            <td>
                                기본 상담 처리 및 회원정보, 계약 관리, 컨텐츠 사용 중 발생하는 각종 서비스 제공 및
                                본인인증 건
                            </td>
                            <td>성명, 생년월일, 주소, 연락처, 이메일, 결제정보, 자녀정보</td>
                        </tr>
                        <tr>
                            <td>㈜ 다우기술</td>
                            <td>문자메시지 전송, 카카오톡 알림톡 전송</td>
                            <td>성명, 휴대폰번호</td>
                        </tr>
                        <tr>
                            <td>㈜ 에코마케팅</td>
                            <td>이벤트 경품 (기프티콘 외) 발송</td>
                            <td>성명, 휴대폰번호</td>
                        </tr>
                        <tr>
                            <td>금융결제원 / ㈜쿠콘 / 주식회사 LG유플러스 / 나이스정보통신㈜</td>
                            <td>멤버십 월회비출금처리, ARS</td>
                            <td>성명, 법정 생년월일, 휴대폰번호, 결제정보</td>
                        </tr>
                        <tr>
                            <td>나이스신용정보㈜</td>
                            <td>미납 및 멤버십 해지 채권에 대한 수납 관리 및 채권 추심</td>
                            <td>성명, 법정 생년월일, 연락처, 결제정보, 자녀 정보</td>
                        </tr>
                        <tr>
                            <td>㈜북센 / 우체국택배 / CJ대한통운㈜ / ㈜이노지스디</td>
                            <td>물품 배송</td>
                            <td>성명, 휴대폰번호, 주소</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <h2>6. 개인정보의 파기와 방법</h2>
                <p>
                    회사는 원칙적으로 이용자 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 회사의
                    개인정보 파기절차 및 방법은 다음과 같습니다.
                </p>
                <h3>가. 파기절차</h3>
                <p>
                    - 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한
                    정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.
                </p>
                <p>- 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</p>

                <h3>나. 파기방법</h3>
                <p>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</p>
                <p>- 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>

                <h3>다. 휴면 계정 전환 및 파기</h3>
                <p>
                    - 관련 법령에 의거하여 1년간 로그인 이력이 없는 경우, 회사는 정리기간을 정하여 사용자에게 해당사실을
                    전자메일 등의 밥법으로 사전 통지합니다.
                </p>
                <p>
                    - 일정기간 고지한 후 관련된 이의 제기가 없을 경우 해당 회원자격을 해지하고, 이에 따라 관련된
                    개인정보는 파기됩니다.
                </p>
            </div>

            <div>
                <h2>7. 이용자의 권리(처리방침)와 그 행사 방법</h2>
                <h3>
                    가. 이용자는 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할
                    수도 있습니다.
                </h3>
                <h3>
                    나. 이용자의 개인정보 조회, 수정을 위해서는 '개인정보변경'(또는 '회원정보수정' 등)을,
                    가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는
                    탈퇴가 가능하며, 대표전화(1577-1500) 또는 개인정보관리자에게 서면이나 전화를 통한 열람, 정정 또는
                    탈퇴 또한 가능합니다.
                </h3>
                <h3>
                    다. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우, 정정 완료 전까지 당해 개인정보를 이용 또는
                    제공하지 않습니다. 또한 잘못된 개인정보를 제3 자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게
                    지체 없이 통지하여 정정이 이루어지도록 하겠습니다.
                </h3>
                <h3>
                    라. 회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "3. 개인정보의 보유 및
                    이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.
                </h3>
            </div>

            <div>
                <h2>8. 이용자의 법정대리인의 권리와 행사 방법</h2>
                <h3>
                    가. 이용자와 법정대리인(이용자가 만14세 미만일 경우)은 언제든지 다음 각 호의 사항에 관하여 개인정보
                    열람·정정을 요구할 수 있습니다.
                </h3>
                <p>1) 회사가 보유하고 있는 이용자의 개인정보</p>
                <p>2) 회사가 이용자의 개인정보를 이용하거나 제3자에게 제공한 내역</p>
                <p>3) 회사에게 개인정보수집·이용·제공 등의 동의를 한 내역</p>
                <h3>나. 이용자와 법정대리인은 언제든지 자신의 개인정보처리의 정지를 요구할 수 있습니다.</h3>
                <h3>
                    다. 이용자와 법정대리인(이용자가 만14세 미만일 경우)은 언제든지 회원가입 시 개인정보의 수집, 이용,
                    제공 등에 대해 동의하신 의사표시를 철회(회원탈퇴)할 수 있습니다.
                </h3>
                <p>단, 동의철회(회원탈퇴)가 있더라도 관계법령에 따라 최소한의 정보가 보관됩니다. </p>
                <h3>
                    라. 이용자(만14세 미만일 경우)가 개인정보에 대하여 아래의 행위를 하는 경우에는 해당 아동의
                    법정대리인의 동의를 얻도록 하고 있습니다.
                </h3>
                <p>
                    - 아동의 서비스가입을 위한 개인정보 수집하거나 서비스 가입 시 고지한 범위 또는 이용약관에 명시한
                    범위를 넘어 아동의 개인정보를 이용하거나 제3자에게 제공하고자 하는 경우
                </p>
                <p>
                    - 아동의 개인정보를 제공받은 자가 개인정보를 제공받은 목적 외의 용도로 이용하거나 제3자에게 제공하는
                    경우
                </p>
                <h3>
                    마. 법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정대리인의 동의 여부를
                    확인하는 목적 외의 용도로 이용하거나 제3자에게 제공하지 않습니다.
                </h3>
            </div>

            <div>
                <h2>9. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h2>
                <p>
                    회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는
                    '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게
                    보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.
                </p>
                <h3>가. 쿠키의 사용 목적</h3>
                <p>
                    사이트 방문객들의 이용형태 분석(접속빈도, 방문시간, 메뉴별 관심도, 관심분야), 이벤트 참여도, 등을
                    파악하여 이용자에게 최적화된 정보 제공을 위하여 사용합니다.
                </p>
                <h3>나. 쿠키의 설치/운영 및 거부</h3>
                <p>
                    - 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을
                    설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을
                    거부할 수도 있습니다.
                </p>
                <p>
                    * 설정방법 예(Internet Explorer의 경우): [도구] 메뉴 &gt; [인터넷 옵션] &gt; [개인정보 탭] &gt;
                    [개인정보취급 수준]설정 (단, 쿠키의 저장을 거부할 경우에는 로그인이 필요한 일부 서비스는 이용에
                    어려움이 있을 수 있습니다.)
                </p>
            </div>

            <div>
                <h2>10. 개인정보의 기술적 / 관리적 보호 대책</h2>
                <h3>
                    가. 회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지
                    않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다
                </h3>
                <p>- 개인정보처리시스템 등의 접근 권한 관리,침입 탐지 및 차단 시스템 가동, 파일 및 전송데이터 암호화</p>
                <p>- 컴퓨터 바이러스에 의한 피해 방지를 위한 자동 Update 백신 이용</p>
                <h3>나. 회사는 고객님의 개인정보보호를 위해 다음과 같은 관리적 조치를 취하고 있습니다.</h3>
                <p>
                    - 개인정보를 취급하는 직원을 최소한으로 줄이고, 정기 또는 수시 교육을 통해 개인정보보호정책을
                    준수하도록 강조하고 있습니다.
                </p>
                <p>
                    - 모든 임직원 및 계약직 사원에게 보안서약서를 제출하게 함으로 사람에 의한 정보유출을 사전에 방지하고
                    있습니다.
                </p>
                <p>
                    - 위반 내용이 확인되는 경우 이를 시정 또는 개선하며 기타 필요한 조치를 취하기 위한 내부절차를
                    마련하고 있습니다.
                </p>
            </div>

            <div>
                <h2>11. 개인정보관리책임자 및 담당자의 연락처</h2>
                <p>
                    스마트올중학은 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이
                    개인정보보호책임자를 지정하고 있습니다
                </p>
                <p>- 개인정보보호책임자 : 웅진씽크빅 경영지원실 실장 _ 이수종</p>
                <p>- 개인정보관리자 : 웅진씽크빅 정보보호팀 팀장 _ 박용구</p>
                <p>- 전화번호 : 1577-1500</p>
                <p>
                    이용자는 서비스를 이용하며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 혹은 담당부서로
                    신고할 수 있습니다.
                </p>
                <p>회사는 이용자들의 신고사항에 대해 빠르고 신속하게 답변을 드리도록 최선을 다 할 것입니다. </p>
                <p>타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                <p>- 대검찰청 사이버 범죄수사단 ( http://spo.go.kr / ☎ 국번없이 1301 )</p>
                <p>- 경찰청 사이버안전국 ( https://ecrm.cyber.go.kr/minwon/main / ☎ 국번없이 182 )</p>
                <p>- 개인정보침해 신고센터 ( http://privacy.kisa.or.kr / ☎ 국번없이 118 )</p>
                <p>- 개인정보 분쟁조정위원회 ( http://kopico.go.kr / ☎ 1833-6972 ) </p>
            </div>

            <div>
                <h2>12. 고지의 의무</h2>
                <p>현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 고지할 것입니다.</p>
            </div>
        </div>
    );
};
